import type { ComponentProps, PropsWithChildren } from 'react'
import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import SolidLockAltIcon from 'LuxKit/Icons/solid/SolidLockAltIcon'
import { getThemeClassName } from 'lib/theme/themeUtils'
import AspectRatio from 'components/utils/AspectRatio'

const ImageWrapper = styled(AspectRatio)`
  position: relative;
  overflow: hidden;
  aspect-ratio: 3/2;
  
  ${mediaQueryUp.tablet} {
    /* Default/fallback size */
    width: ${rem(512)};
    height: ${rem(200)};
    
    &.small {
      width: ${rem(320)};
      height: ${rem(160)};
    }
  }
`

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  display: grid;
  place-items: center;
  backdrop-filter: blur(12px);
`

interface Props extends PropsWithChildren, Pick<ComponentProps<typeof AspectRatio>, 'ratio' | 'tabletRatio' | 'desktopRatio' | 'largeDesktopRatio'> {
  size?: 'small' | 'medium'
}

function LuxPlusHiddenOfferImageContainer(props: Props) {
  const {
    children,
    size,
    ratio,
    tabletRatio,
    desktopRatio,
    largeDesktopRatio,
  } = props

  return <ImageWrapper className={size} ratio={ratio} tabletRatio={tabletRatio} desktopRatio={desktopRatio} largeDesktopRatio={largeDesktopRatio}>
    {children}
    <Overlay>
      <SolidLockAltIcon colour="neutral-eight" size="XL" className={getThemeClassName({ mobile: 'default' })} />
    </Overlay>
  </ImageWrapper>
}

export default LuxPlusHiddenOfferImageContainer
